
import React, { useState, useEffect } from 'react';
import Footer from 'components/Footer';
import Heading from 'components/Heading';
import { Helmet } from 'react-helmet';
import styles from './videography.module.css';

// Import the video data from the JSON file
import videoData from 'assets/video_project/video.json';  // Adjust the path if necessary
import { useParams } from 'react-router-dom';
export const Videography = () => {
  let { param } = useParams(); // Get the category from the URL
 
  
  const [category, setCategory] = useState('PROMOTIONAL AND EVENT COVERAGE'); // Default category
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    // Check if the URL parameter exists and is valid
    if (param && videoData[decodeURIComponent(param)]) {
      setCategory(decodeURIComponent(param)); // Set the category based on the URL
    }
  }, [param]);

  useEffect(() => {
    // Fetch videos based on the current category
    if (category && videoData[category]) {
      setVideos([{ category, videos: videoData[category] }]);
    } else {
      setVideos([]); // No videos if the category doesn't exist
    }
  }, [category]);

  const openModal = (videoId) => {
    setVideoUrl(`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&showinfo=0&rel=0&modestbranding=1`);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setVideoUrl('');
  };

  return (
    <>
<Helmet>
  <title>Videography Services - Shutterfly</title>
  <meta 
    name="description" 
    content="Discover Shutterfly's professional videography services, capturing memorable moments with creativity, high-quality visuals, and compelling storytelling." 
  />
  <meta name="keywords" content="Shutterfly, videography, professional videos, creative storytelling, high-quality visuals" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://shutterfly-eg.com/videography" />
</Helmet>
      <header className={styles.header} role="banner">
      <Heading  align='center' as='h1'>{category}</Heading>
      </header>
      

        <section className={styles.videos} id="featured-videos">
          <div className={styles['video-grid']} id="front-page-videos">
            
              {videos.length > 0 ? (
                videos.map((categoryData, index) => (
                  <ul className={styles['video-list']}>
                    {categoryData.videos.map((videoUrl, index) => {
                      const videoId = videoUrl.split('/').pop().split('?')[0];  // Extract the video ID from the URL
                      return (
                        <li key={index} className={styles.video}>
                          <button
                            className={styles['featured-video']}
                            onClick={() => openModal(videoId)}
                          >
                            <figure
                              className={styles['video-figure']}
                              style={{ backgroundImage: `url(https://img.youtube.com/vi/${videoId}/hqdefault.jpg)` }}
                            >
                              <img
                                className={styles['thumbnail']}
                                src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/50598/video-thumb-placeholder-16-9.png"
                                alt="Thumbnail"
                              />
                              {/* <figcaption className={styles['video-caption']}>{`Video ${index + 1}`}</figcaption> */}
                            </figure>
                          </button>
                          </li>
                      );
                    })}
                  </ul>
                ))
              ) : (
                <p>No videos available for this category.</p>
              )}
            
          </div>
        </section>

        {isModalOpen && (
          <div className={styles.modal}>
            <div className={styles.modalContent}>
              <button className={styles.closeModal} onClick={closeModal}>X</button>
              <iframe
                className={styles['video-iframe']}
                width="100%"
                height="100%"
                src={videoUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      

      <Footer />
    </>
  );
};